import styled from "styled-components";
import { Row, Col, Popover, Typography, Tooltip, message } from "antd";
import Pills from "modules/Common/Components/Pills";
import Input from "../../../Common/Components/Input";
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import ActionCard from "./ActionCard";
import BlogItemTwo from "modules/Common/Components/BlogItemTwo";
import RecommendedCard from "modules/Common/Components/RecommendedCard";
import SearchTerm from "../../../Content/Search/Components/SearchTerm";
import UserItem from "../../Shared/UserItem";
import CompanyCard from "../../../Content/Shared/CompanyCard";
import TickNormal from "../../../../assets/img/icons/tickNormal.svg";
import crossNormal from "../../../../assets/img/icons/crossNormal.svg";
import EditIcon from "../../../../assets/img/icons/Edit.svg";
import Speed from "../../../../assets/img/icons/Speed.svg";
import Send from "../../../../assets/img/icons/Send.svg";
import Import from "../../../../assets/img/icons/Import.svg";
import Global from "../../../../assets/img/icons/global.svg";
import Email from "../../../../assets/img/icons/Hoc-email.svg";
import Linkedin from "../../../../assets/img/icons/ArticlePopover/linkedin-Gray.svg";
import Twitter from "../../../../assets/img/icons/ArticlePopover/twitter-Gray.svg";
import Elipsis from "../../../../assets/img/icons/Elipsis.svg";
import addWhite from "../../../../assets/img/icons/addWhiteBig.svg";
import addGreen from "../../../../assets/img/icons/plus-5.svg";

import List from "../../../../assets/img/icons/ArticlePopover/lowerList/list.svg";
import Profile from "../../../../assets/img/icons/ArticlePopover/lowerList/profile.svg";
import Frame from "../../../../assets/img/icons/ArticlePopover/lowerList/frame.svg";
import Delete from "../../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import Search from "../../../../assets/img/icons/ArticlePopover/lowerList/search.svg";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { useEffect, useState } from "react";
import DonutChart from "modules/Content/Shared/DonutChart";
import Message from "modules/Common/Components/Message";
import CreateCampaign from "modules/Campaigns/CampaignAssets/Components/CreateCampaign";
import FloatingNewListAsider from "../Lists/FloatingNewListAsider";
import AggregateEngagementChart from "./AggregateEngagementChart";
import ContactDetailLoaderActionCards from "modules/Common/Components/ContactDetailLoaderActionCards";
import ContactDetailLoaderProfileData from "modules/Common/Components/ContactDetailLoaderProfileData";
import DetailProfileLoaderCard from "modules/Common/Components/DetailProfileLoaderCard";
import { XIQ_SALES_XELERATOR_URL } from "constants/index";
import { AUDIENCE_CONTACT_DETAILS } from "constants/actionTypes";
import CustomSelectAsset from "modules/Design/Assets/CustomSelectAsset";
import { addGillRoyIcon, getQueryListId } from "utils";
import { AUDIENCE_LISTS, AUDIENCE_LISTS_ADD } from "constants/types";
import { getAudienceListsNamesOnlyService } from "modules/Services/AudienceService";
import NewListModule from "../Components/NewListModule";
import FooterActionButton from "modules/Campaigns/CampaignAssets/Components/FooterActionButton";
import { createNewAudienceList, resetAlreadyExistListErrorMessage } from "../Lists/actions";
import { useHistory } from "react-router-dom";
import { closeDetailProfile } from "modules/GlobalActions";
import { addListContact, getContactEngagement, getContactSimilar, getContactSubscriptions } from "../actions";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import BlankProfilePhoto from '../../../../assets/img/blank_profile_photo.png';

const { Paragraph } = Typography;

interface IDetailProfileProps {
  imgUrl?: string;
  name?: string;
  designation?: string;
  organization?: string;
  engagement?: number;
  type?: string;
  showEditContactAsiderHandler?: (value: boolean) => void;
  // hideEditContact?: boolean;
}

const DetailProfile: React.FC<IDetailProfileProps> = (props) => {
  // const [showNewListAsider, setShowNewListAsider] = useState(false);
  const error = useSelector((state: RootState) => state.audienceListDetails.delete.fail);

  const contactDetails = useSelector((state: RootState) => state.peopleAudience.contactDetails);
  const contactId = contactDetails.contact_id;

  // console.log("CONTACT DETAILS: ", contactDetails);

  const contactDashboard: any = useSelector((state: RootState) => state.peopleAudience.contactDashboard);
  // console.log("CONTACT DASHBOARD: ", contactDashboard);

  const contactSubscriptions: any = useSelector((state: RootState) => state.peopleAudience.contactSubscriptions);
  const peopleAudienceReducer: any = useSelector((state: RootState) => state.peopleAudience);
  // console.log("CONTACT SUBSCRIPTIONS: ", contactSubscriptions);

  const contactEngagement: any = useSelector((state: RootState) => state.peopleAudience.contactEngagement);
  // console.log("CONTACT Engagement: ", contactEngagement);

  const contactSimilar: any = useSelector((state: RootState) => state.peopleAudience.contactSimilar);
  // console.log("CONTACT Similar: ", contactSimilar);

  const ListAddSuccess = useSelector((state: RootState) => state.audienceLists.addList.success);

  const showDetailProfile = useSelector((state: RootState) => state.audience.showDetailProfile);
  const listDataNamesLoading: any = useSelector((state: RootState) => state.audienceLists.listsDataNamesLoading);
  const listDataNames: any = useSelector((state: RootState) => state.audienceLists.listsDataNames);
  const listAlreadyExists = useSelector((state: RootState) => state.audienceLists.listAlreadyExists);
  const newListCreated = useSelector((state: RootState) => state.audienceLists.newListCreated);
  const showDetailsTabAddContactSuccessMessage = useSelector((state: RootState) => state.audienceLists.showDetailsTabAddContactSuccessMessage);


  const [dashboardIsActive, setDashboardIsActive] = useState(true);
  const [subscriptionsIsActive, setSubscriptionsIsActive] = useState(false);
  const [engagementIsActive, setEngagementIsActive] = useState(false);
  const [similarIsActive, setSimilarIsActive] = useState(false);
  const [similarContactNamesState, setSimilarContactNamesState] = useState<string[]>([]);
  const [similarContactIdsState, setSimilarContactIdsState] = useState<any[]>([]);
  const [similarContactsState, setSimilarContactsState] = useState<any[]>([]);
  const [ellipsisState, setEllipsistate] = useState(false);
  const [showNewListModule, setShowNewListModule] = useState(false);
  const [selectedList, setSelectedList] = useState({ name: "", id: "" });
  const [listName, setListName] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [errorList, setError] = useState("");
  const [disableButtonInList, setDisableButtonInList] = useState(false);
  const [newListErrorMessage, setNewListErrorMessage] = useState(false);
  const [addContactLoading, setAddContactLoading] = useState(false); // loading state for add contact to list button in details tab
  const history = useHistory();


  useEffect(() => {
    const similarContactNames: string[] = [];
    const similarContactIds: any[] = [];
    const similarContacts: any[] = [];
    contactSimilar?.length > 0 &&
      contactSimilar?.map((contact: any, index: number) => {
        similarContactNames.push(contact.contact_name);
        similarContactIds.push(contact.contact_id);
        similarContacts.push({ id: contact.contact_id, name: contact.contact_name, audience_type: "" });
      });
    setSimilarContactNamesState(similarContactNames);
    setSimilarContactIdsState(similarContactIds);
    setSimilarContactsState(similarContacts);
  }, [contactSimilar]);

  useEffect(() => {
    if (!showDetailProfile) {
      onDashboardPillClick();
      resetContactDetails();
      setEllipsistate(false);
      setShowNewListModule(false);
      setSelectedList({ name: "", id: "" });
      setAddContactLoading(false);
      //audienceListNames();
      setNewListErrorMessage(false);
      cancelHandle();
    }
  }, [showDetailProfile]);

  useEffect(() => {
    if (listAlreadyExists) {
      setNewListErrorMessage(true);
      setTimeout(() => {
        resetAlreadyExistListErrorMessage();
      }, 2000);
    }
  }, [listAlreadyExists]);

  useEffect(() => {

    // show success message when contact is added to a list from details tab
    if ((getQueryListId() || getQueryCampaignId() || window.location.pathname.startsWith("/audiences")) && showDetailsTabAddContactSuccessMessage) {
      // new list created and contact added to it
      if (newListCreated) {
        message.success(`Your list (${listName}) has been created and contact (${contactDetails?.contact_name?.trim()
          ? contactDetails?.contact_name?.trim()
          : contactDetails?.contact_email
          }) has been added successfully`)
        setTimeout(() => {
          if (newListErrorMessage) setNewListErrorMessage(false);
          store.dispatch({
            type: AUDIENCE_LISTS_ADD.NEWLY_CREATED_LIST_CHECK,
            newListCreated: false,
          });
        }, 2000);
      } else {
        // contact added to an existing list
        message.success(`Your Contact (${contactDetails?.contact_name?.trim()
          ? contactDetails?.contact_name?.trim()
          : contactDetails?.contact_email
          }) has been added to a list (${selectedList?.name}) successfully`);
      }

      // close the details tab
      closeDetailProfile();
      addGillRoyIcon();

      // reset the flag after 1 second
      setTimeout(() => {
        store.dispatch({
          type: AUDIENCE_LISTS_ADD.DETAILS_SUCCESS_MESSAGE,
          flag: false
        })
        setSelectedList({ name: "", id: "" });
        setAddContactLoading(false);
      }, 2000);
    }
  }, [showDetailsTabAddContactSuccessMessage])

  const audienceListNames = () => {
    if (listDataNames.length === 0) {
      store.dispatch({
        type: AUDIENCE_LISTS.NAMES_LOAD,
      });
      getAudienceListsNamesOnlyService()
        .then((res) => {
          const { lists } = res.data;
          if (lists.length > 0) {
            store.dispatch({
              type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
              listsDataNames: lists,
              payload: { listsDataNames: lists, },
            });
          }
        })
        .catch((err) => {
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_FAIL,
          });
        });
    }
    //cancelHandle();
  }
  const resetContactDetails = () => {
    store.dispatch({
      type: AUDIENCE_CONTACT_DETAILS.RESET,
      payload: { loading: true },
    });
  };

  const onDashboardPillClick = () => {
    setDashboardIsActive(true);
    setSubscriptionsIsActive(false);
    setEngagementIsActive(false);
    setSimilarIsActive(false);
  };
  const onSubscriptionsPillClick = () => {
    getContactSubscriptions(contactId?.toString());
    setDashboardIsActive(false);
    setSubscriptionsIsActive(true);
    setEngagementIsActive(false);
    setSimilarIsActive(false);
  };
  const onEngagementPillClick = () => {
    getContactEngagement(contactId?.toString());
    setDashboardIsActive(false);
    setSubscriptionsIsActive(false);
    setEngagementIsActive(true);
    setSimilarIsActive(false);
  };
  const onSimilarPillClick = () => {
    getContactSimilar(contactId?.toString());
    setDashboardIsActive(false);
    setSubscriptionsIsActive(false);
    setEngagementIsActive(false);
    setSimilarIsActive(true);
  };

  const editContactHandler = () => {
    props.showEditContactAsiderHandler && props.showEditContactAsiderHandler(true);
    setShowNewListModule(false);
  };

  const formatConcepts = (concepts: any) => {
    return concepts?.map(({ text, relevance }: any) => {
      return {
        name: text,
        y: Math.floor(Number(relevance) * 100),
      };
    });
  };

  const handleSelectedList = (e: any) => {
    let contact = listDataNames?.find(
      (item: any) => e?.toString() === item?.list_id?.toString()
    )
    console.info('Saved One');
    if (contact) {
      console.info('Saved');
      setSelectedList({ name: contact?.list_name, id: contact?.list_id });
    }
    setShowNewListModule(false);
    if (getQueryListId() !== parseInt(e)) {
      addListContact(e, contactId.toString(), -1, true, 0, true);
      setAddContactLoading(true);
    }
  };

  const onClickCreateList = (e: any) => {
    setShowNewListModule(true);
    setListName("");
  };

  const handleInputChangeNewList = (e: any) => {
    let value = e.target.value;
    if (value.trim().length === 0) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
    // handling ',' in list name to avoid any issue in publish emails fileds
    if (value.includes(",")) {
      setError("',' is not allowed in list names.");
    } else {
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (!specialChars.test(value)) setListName(value);
      if (errorList) setError("");
      // if (window.location.pathname.startsWith("/audiences/lists") && disableButtonInList)
      //   setDisableButtonInList(false);
    }
    if (disableButtonInList) {
      setDisableButtonInList(false);
    }
    setNewListErrorMessage(false);
  };

  const cancelHandle = () => {
    setListName("");
    store.dispatch({ type: AUDIENCE_LISTS_ADD.RESET });
    setError("");
    setShowNewListModule(false);
    setSelectedList({ name: "", id: "" });
    setAddContactLoading(false);
    setNewListErrorMessage(false);
  };

  function handleCreateNewList() {
    createNewAudienceList(
      cancelHandle,
      setDisableButtonInList,
      setShowNewListModule,
      history,
      listName?.trim(),
      [contactId],
      false,
      0,
      '',
      false,
      [],
      true,
      '',
      true,
      [],
      [],
      [],
      [],
      '',
      true,
      true
    );
    setDisableButton(true);
  }

  return (
    <Wrapper color={contactDetails?.color}>
      <div className="default-profile">
        <div className="top-row">
          {contactDetails?.person_id ? (
            <div className="send-btn">
              <a
                href={`${XIQ_SALES_XELERATOR_URL}person/personalityinsights?personId=${contactDetails?.person_id}&personType=EXECUTIVE`}
                target="_blank"
                rel="noreferrer"
              >
                <ButtonRightIcon label="Sales Xelerator" icon={Send} />
              </a>
            </div>
          ) : (
            <div className="send-btn"></div>
          )}
          <div className="profile-pic">
            <img
              src={
                contactDetails?.thumbnail
                  ? contactDetails?.thumbnail
                  : BlankProfilePhoto
              }
              alt=""
            />
            <span data-qa="qa-personality">{contactDetails?.personality}</span>
          </div>
        </div>
        <div className="middle-row">
          {contactDetails.loading === true ? (
            <>
              <ContactDetailLoaderProfileData />
            </>
          ) : (
            <Row gutter={16}>
              <Col span="18" className="gutter-row">
                <div className="edit-wrapper ">
                  {/* Toggle editable-active class */}
                  <span className="name">
                    <h2 id="asset_name" className="asset-name new-campaign" data-qa="qa-campaign-name">
                      {contactDetails?.contact_name?.trim() === "" ? (
                        <Tooltip placement="top" title={ellipsisState ? contactDetails?.contact_email : undefined}>
                          <Paragraph ellipsis={{ rows: 1, expandable: false, onEllipsis: setEllipsistate }}>
                            {contactDetails?.contact_email}
                          </Paragraph>
                        </Tooltip>
                      ) : (
                        <Tooltip placement="top" title={ellipsisState ? contactDetails?.contact_name : undefined}>
                          <Paragraph ellipsis={{ rows: 2, expandable: false, onEllipsis: setEllipsistate }}>
                            {contactDetails?.contact_name}
                          </Paragraph>
                        </Tooltip>
                      )}
                    </h2>
                    {/* <span className="edit-icon">
                      <div className="tooltip">
                        <img src={EditIcon} alt="edit" />
                        <span className="tooltiptext">Edit</span>
                      </div>
                    </span> */}
                    <div className={"editable"}>
                      <Input type="text" placeholder={contactDetails?.contact_name} />
                      <span className="save">
                        <img src={TickNormal} alt="save" />
                      </span>
                      <span className="cancel">
                        <img src={crossNormal} alt="cancel" />
                      </span>
                    </div>
                  </span>
                </div>
              </Col>
              <Col span="6" className="gutter-row d-flex align-items-center justify-content-end">
                <div className="engagement" data-qa="qa-score">
                  <img src={Speed} />
                  &nbsp;
                  {contactDetails?.engagement_score}
                </div>
              </Col>
              <Col span="24" className="gutter-row">
                <div className="comapny-row d-flex">
                  <div className="company-logo">
                    {contactDetails?.company_logo ? (
                      <img src={contactDetails?.company_logo} />
                    ) : (
                      <img src="https://media.xiq.io/static/default_campaign_img.png" />
                    )}
                  </div>
                  <div className="company-details flex-grow-1">
                    <p className="name mb-0" data-qa="qa-comp-name">
                      {" "}
                      <Tooltip placement="top" title={contactDetails?.organization}>
                        {contactDetails?.organization}
                      </Tooltip>
                    </p>
                    <p className="designation mb-0"> <Tooltip placement="top" title={contactDetails?.designation}>
                      {contactDetails?.designation}
                    </Tooltip> </p>
                  </div>
                  <div className="company-details flex-grow-1 px-0" onClick={() => audienceListNames()}>
                    <CustomSelectAsset
                      campaigns_list={[]}
                      disabled={addContactLoading}
                      listDataNamesLoading={listDataNamesLoading}
                      inList={true}
                      listsData={getQueryListId() ? listDataNames.filter((list: any) => list.listId != getQueryListId()) : listDataNames}
                      campaignName={"Add to List"}
                      selectedValue={
                        showNewListModule
                          ? "Create new list"
                          : selectedList?.name
                      }
                      setCampaignName={(value: string) => {
                        setListName(value);
                      }}
                      setSelectedCampaign={handleSelectedList}
                      onClickCreateCampaign={(value: any) => {
                        onClickCreateList(value);
                      }}
                      inContactDetail={true}
                      showNewListModule={showNewListModule}
                      cancelHandle={cancelHandle}
                      listProfileDetail
                    />
                    {showNewListModule ? (
                      <div className={showNewListModule ? "new-campaign-bottom style-for-campaign" : "d-none"}>
                        <NewListModule listName={listName} setListName={handleInputChangeNewList} newListErrorMessage={newListErrorMessage} addNewListFlow />
                        <FooterActionButton>
                          <span className={`footer-btn mr`} onClick={cancelHandle}>
                            Cancel
                          </span>
                          <span
                            className={`footer-btn filled-success ${disableButton || listName.length === 0 ? "disabled" : ""
                              }`}
                            data-id="qa-save-btn"
                            onClick={handleCreateNewList}
                          >
                            Save
                          </span>
                        </FooterActionButton>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                </div>
                <div className="comapny-row d-flex mb-1 justify-content-between">
                  <div className="company-action ml-auto" data-qa="qa-web-links">
                    <ul>
                      {contactDetails.company_website !== "" && (
                        <li className="ps-0 ms-0">
                          <a href={`https://${contactDetails.company_website}`} target="_blank" rel="noreferrer">
                            <img src={Global} alt="" />
                            <span>Website</span>
                          </a>
                        </li>
                      )}
                      {contactDetails.contact_email !== "" && (
                        <li>
                          <a href={`mailto:${contactDetails.contact_email}`}>
                            <img src={Email} alt="" />
                            <span>Email</span>
                          </a>
                        </li>
                      )}
                      {contactDetails.twitter_url !== "" && (
                        <li>
                          <a href={contactDetails.twitter_url} target="_blank" rel="noreferrer">
                            <img src={Twitter} alt="" />
                            <span>Twitter</span>
                          </a>
                        </li>
                      )}
                      {contactDetails.linkedin_url !== "" && (
                        <li>
                          <a href={contactDetails.linkedin_url} target="_blank" rel="noreferrer">
                            <img src={Linkedin} alt="" />
                            <span>Linkedin</span>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="edit-btn-col">
                    <ButtonRightIcon onClick={editContactHandler} label="Edit Contact" noIcon />
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {!contactDetails.loading &&
            <Row gutter={16}>
              <Col>
                <div className="total-delivered">
                  <span className="total-delivered-text">Emails Sent (Delivered%) : </span>
                  <span className="total-delivered-numericals">{contactDetails.total_sent} ({contactDetails.delivery_rate})</span>
                </div>
              </Col>
            </Row>
          }

          <Row gutter={16}>
            {contactDetails.loading === true ? (
              <div className="loader">
                <ContactDetailLoaderActionCards />
              </div>
            ) : (
              <>
                <Col span="6" className="gutter-row" data-qa="qa-total-open">
                  <ActionCard
                    color="#FF9531"
                    title="Total Opens"
                    count={contactDetails?.total_opens?.toLocaleString()}
                    rate={`${contactDetails?.open_rate}% open rate`}
                  />
                </Col>
                <Col span="6" className="gutter-row" data-qa="qa-total-click">
                  <ActionCard
                    color="#27CE0A"
                    title="Total Clicks"
                    count={contactDetails?.total_clicks?.toLocaleString()}
                    rate={`${contactDetails?.click_rate}% click rate`}
                  />
                </Col>
                <Col span="6" className="gutter-row" data-qa="qa-unique-open">
                  <ActionCard
                    color="#001760"
                    title="Unique Opens"
                    count={contactDetails?.average_opens?.toLocaleString()}
                    rate={`${contactDetails?.average_open_rate}% open rate`}
                  />
                </Col>
                <Col span="6" className="gutter-row" data-qa="qa-unique-click">
                  <ActionCard
                    color="#C21E9F"
                    title="Unique Clicks"
                    count={contactDetails?.average_clicks?.toLocaleString()}
                    rate={`${contactDetails?.average_click_rate}% click rate`}
                  />
                </Col>
              </>
            )}
            {/* <Col span="24" className="gutter-row mt-4">
              <div className="instasite">
                <ButtonRightIcon
                  outlineClass="green-outline"
                  label={`Create a personalized InstaSite for ${contactDetails.contact_name}`}
                  icon={Import}
                />
              </div>
            </Col> */}
            <Col span="24" className="gutter-row mt-1">
              <div className="d-flex justify-content-center">
                {/* tabs listing  */}
                <div className="tabs-wrapper d-flex padding-top-md padding-bottom-lg">
                  <ul>
                    <li onClick={onDashboardPillClick} data-qa="qa-dashboard">
                      <Pills title="Dashboard" active={dashboardIsActive} />
                    </li>
                    <li onClick={onSubscriptionsPillClick} data-qa="qa-subscribe">
                      <Pills title="Subscriptions" active={subscriptionsIsActive} />
                    </li>
                    <li onClick={onEngagementPillClick} data-qa="qa-engage">
                      <Pills title="Engagement" active={engagementIsActive} />
                    </li>
                    <li onClick={onSimilarPillClick} data-qa="qa-similar">
                      <Pills title="Similar" active={similarIsActive} />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tabs-content-wrapper padding-bottom-lg">
                {/* Dashboard Tab */}
                {dashboardIsActive === true && (
                  <>
                    <h4 className="recommended-title">Recommended Campaigns for {contactDetails.contact_name}:</h4>
                    {contactDashboard.loading === true ? (
                      <DetailProfileLoaderCard />
                    ) : contactDashboard?.assets?.length > 0 ? (
                      contactDashboard?.assets?.map((obj: any, index: any) => {
                        const { images, name, campaign_name, id } = obj;
                        return (
                          <RecommendedCard
                            contactId={contactId}
                            assetId={id}
                            title={name}
                            company={campaign_name}
                            imgUrl={images[0] ?? ""}
                            imgUrlTwo={images[1] ?? ""}
                            imgUrlThree={images[2] ?? ""}
                            stylev1={false}
                            key={index}
                            index={index}
                          />
                        );
                      })
                    ) : (
                      <span className="no-data-text-style">No data available!</span>
                    )}
                    <h4 className="recommended-title">Recommended Lists for {contactDetails.contact_name}:</h4>
                    {contactDashboard.loading === true ? (
                      <DetailProfileLoaderCard />
                    ) : contactDashboard?.lists?.length > 0 ? (
                      contactDashboard?.lists?.map((obj: any, index: any) => {
                        const { images, name, id } = obj;
                        return (
                          <RecommendedCard
                            contactId={contactId}
                            listId={id}
                            title={name}
                            imgUrl={images[0] ?? ""}
                            imgUrlTwo={images[1] ?? ""}
                            imgUrlThree={images[2] ?? ""}
                            stylev1={false}
                            isList={true}
                            key={index}
                            index={index}
                          />
                        );
                      })
                    ) : (
                      <span className="no-data-text-style">No data available!</span>
                    )}
                  </>
                )}
                {/* Subscription Tab */}
                {subscriptionsIsActive === true && (
                  <>
                    <h4 className="recommended-title">Subscribed Campaigns:</h4>
                    {contactSubscriptions.loading === true ? (
                      <DetailProfileLoaderCard />
                    ) : peopleAudienceReducer.contactSubscriptions.subscribed_campaigns &&
                      peopleAudienceReducer.contactSubscriptions.subscribed_campaigns?.length > 0 ? (
                      peopleAudienceReducer.contactSubscriptions.subscribed_campaigns?.map(
                        (obj: any, index: any) => {
                          const { thumbnails, name, campaign_name, campaign_id } = obj;
                          return (
                            <RecommendedCard
                              minusIcon={true}
                              contactId={contactId}
                              subscribed_assetId={campaign_id}
                              title={name}
                              company={campaign_name}
                              imgUrl={thumbnails[0] ?? ""}
                              imgUrlTwo={thumbnails[1] ?? ""}
                              imgUrlThree={thumbnails[2] ?? ""}
                              stylev1={false}
                              key={index}
                              index={index}
                            />
                          );
                        }
                      )
                    ) : (
                      <span className="no-data-text-style">No data available!</span>
                    )}
                    <h4 className="recommended-title">Subscribed Lists:</h4>
                    {error ? (
                      <Message marginBottom="10" type="error" label="ERROR" message="Cannot perform action!" />
                    ) : (
                      ""
                    )}
                    {contactSubscriptions.loading === true ? (
                      <DetailProfileLoaderCard />
                    ) : peopleAudienceReducer.contactSubscriptions.subscribed_lists &&
                      peopleAudienceReducer.contactSubscriptions.subscribed_lists?.length > 0 ? (
                      peopleAudienceReducer.contactSubscriptions.subscribed_lists?.map((obj: any, index: any) => {
                        const { thumbnails, name, id } = obj;
                        return (
                          <RecommendedCard
                            inDetailProfile={true}
                            isProfiled={contactDetails.profiled}
                            minusIcon={true}
                            contactId={contactId}
                            subscribed_listId={id}
                            title={name}
                            imgUrl={thumbnails[0] ?? ""}
                            imgUrlTwo={thumbnails[1] ?? ""}
                            imgUrlThree={thumbnails[2] ?? ""}
                            stylev1={false}
                            isList={true}
                            key={index}
                            index={index}
                          />
                        );
                      })
                    ) : (
                      <span className="no-data-text-style">No data available!</span>
                    )}
                  </>
                )}
                {/* Engagement Tab */}
                {engagementIsActive && (
                  <>
                    {contactEngagement.loading ? (
                      <>
                        <br />
                        <DetailProfileLoaderCard />
                      </>
                    ) : contactEngagement?.aggregate_graph &&
                      contactEngagement?.aggregate_graph?.total_clicks?.length > 0 &&
                      contactEngagement?.aggregate_graph?.total_opens?.length > 0 ? (
                      <div className="engagement-chart">
                        <AggregateEngagementChart
                          plotData={contactEngagement?.aggregate_graph}
                          title={"Aggregate engagement"}
                        />
                      </div>
                    ) : (
                      <div className="mt-3">
                        <span className="no-data-text-style">No data available!</span>
                      </div>
                    )}

                    {!contactEngagement.loading && contactEngagement?.entities?.length > 0 && (
                      <h4 className="recommended-title">Top Entities for {contactDetails.contact_name}:</h4>
                    )}
                    <Row gutter={12}>
                      {contactEngagement.loading ? (
                        <>
                          <h4 className="recommended-title">Top Entities for {contactDetails.contact_name}:</h4>
                          <DetailProfileLoaderCard />
                        </>
                      ) : contactEngagement?.entities && contactEngagement?.entities?.length > 0 ? (
                        contactEngagement?.entities?.map((entity: any, index: number) => (
                          <Col key={index} span="8" className="gutter-row">
                            <CompanyCard companyName={entity.entity} hideMentions />
                          </Col>
                        ))
                      ) : (
                        <></>
                      )}
                    </Row>
                    {!contactEngagement.loading && contactEngagement?.concepts?.length > 0 && (
                      <h4 className="recommended-title">Top Concepts for {contactDetails.contact_name}:</h4>
                    )}
                    {contactEngagement.loading ? (
                      <>
                        <h4 className="recommended-title">Top Concepts for {contactDetails.contact_name}:</h4>
                        <DetailProfileLoaderCard />
                      </>
                    ) : contactEngagement?.concepts && contactEngagement?.concepts?.length > 0 ? (
                      <DonutChart data={formatConcepts(contactEngagement?.concepts)} backgroundColor={"#F9F8F6"} />
                    ) : (
                      <></>
                    )}

                    {!contactEngagement.loading && contactEngagement?.keywords?.length > 0 && (
                      <h4 className="recommended-title">Top Keywords for {contactDetails.contact_name}:</h4>
                    )}
                    <div className="justify d-flex flex-wrap justify-content-start">
                      {contactEngagement.loading ? (
                        <>
                          <h4 className="recommended-title">Top Keywords for {contactDetails.contact_name}:</h4>
                          <DetailProfileLoaderCard />
                        </>
                      ) : contactEngagement?.keywords && contactEngagement?.keywords?.length > 0 ? (
                        contactEngagement?.keywords?.map((keyword: any, index: number) => (
                          <SearchTerm key={index} removeCross searchTerm={keyword.keyword} />
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                    {!contactEngagement.loading && contactEngagement?.content?.length > 0 && (
                      <h4 className="recommended-title">Most Engaged Content:</h4>
                    )}
                    {contactEngagement.loading ? (
                      <>
                        <h4 className="recommended-title">Most Engaged Content:</h4>
                        <DetailProfileLoaderCard />
                      </>
                    ) : contactEngagement?.content && contactEngagement?.content?.length > 0 ? (
                      contactEngagement?.content?.map((card: any, index: number) => (
                        <div key={index} className="mb-2">
                          <BlogItemTwo
                            engagementIsActive={engagementIsActive}
                            articlePreviewInDetailProfile
                            className="mb-2"
                            imgUrl={card.image ?? ""}
                            title={card.name}
                            website={`${card.url.substr(0, 20)}${card.url.length > 20 ? "..." : ""}`}
                            articleId={card.articleid}
                            // tags={card.keywords.join(", ")}
                            publishDate={card.last_click_date}
                            // hideMenu={true}
                            link={card.url}
                            hideCheckBox={true}
                            inEngagementTab={true}
                            showFav={false}
                          />
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </>
                )}
                {/* Similar Tab */}
                {similarIsActive && (
                  <>
                    <div
                      className={`d-flex justify-content-between mt-4 ${contactSimilar.loading ? "disable-click" : ""
                        }`}
                    >
                      <CreateCampaign
                        similarContactNames={similarContactNamesState}
                        similarContactIds={similarContactIdsState}
                        hideDynamic={true} // enable overlay if campaign is called within a component
                        contactSidebarId={contactId?.toString()}
                        inDetailProfile={true}
                      >
                        <ButtonRightIcon
                          green="green"
                          label="Campaign from Similar"
                          icon={addWhite}
                          disable={contactSimilar.loading}
                        />
                      </CreateCampaign>
                      <FloatingNewListAsider
                        inDetailProfile={true}
                        contactSidebarId={contactId}
                        similarContacts={similarContactsState}
                        idprefix="similar-list"
                      >
                        <ButtonRightIcon
                          disable={contactSimilar.loading}
                          outlineClass="green-outline"
                          label="List from Similar"
                          icon={addGreen}
                        />
                      </FloatingNewListAsider>
                    </div>
                    <h4 className="recommended-title">Similar Contacts:</h4>
                    {contactSimilar.loading ? (
                      <DetailProfileLoaderCard />
                    ) : contactSimilar && contactSimilar?.length > 0 ? (
                      contactSimilar?.map((item: any, index: number) => (
                        <UserItem
                          key={index}
                          id={item.contact_id}
                          name={item.contact_name}
                          email={item.contact_email}
                          color={item.color}
                          profileImage={item.thumbnail}
                          company={item.organization}
                          designation={item.designation}
                          hideEllipsis={true}
                          clicks={item.engagement_score}
                        />
                      ))
                    ) : (
                      <span className="no-data-text-style">No data available!</span>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* <FloatingNewListAsider
        similarContacts={similarContacts}
        showNewListAsider={showNewListAsider}
        setShowNewListAsider={setShowNewListAsider}
      /> */}
    </Wrapper>
  );
};

export default DetailProfile;

DetailProfile.defaultProps = {
  imgUrl: "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  name: "Olivia Arribas",
  designation: "President/ Co-founder",
  organization: "Hoeger and Sons",
  type: "Motivator",
  engagement: 1001,
};
const Wrapper = styled.div`
  .donut-chart-container {
    background: none;
  }
  .style-for-campaign {
    position: absolute;
    z-index: 11;
    top: 28px;
    right: 8px;
    width: 300px;
    height: 325px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 30px;
      height: 288px;
    }
    .dropdown-create-new-list{
      border: 1px solid #1EC252;
      box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 20%);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 10px;
      }
    }
    .footer-wrapper {
      background: #ECFAF1;
      border-top: 0px;
      bottom: 20px;
      border: 1px solid #1EC252;
      border-top: none;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        bottom: 30px;
      }
    }
  }
  .default-profile {
    .no-data-text-style {
      font-size: 18px;
      font-weight: 400;
      font-family: "Roboto Slab", serif;

      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    .disable-click {
      pointer-events: none;
    }
    div.engagement-chart {
      margin-top: 30px;
    }
    h4.recommended-title {
      color: #7e7e7e;
      font-size: 18px;
      font-weight: 400;
      font-family: "Roboto Slab", serif;
      margin: 30px 0 16px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
        margin: 20px 0 10px 0;
      }
    }
    .top-row {
      position: relative;
      padding-top: 13px;
      .profile-pic {
        position: relative;
        text-align: center;
        padding-top: 15px;
        z-index: 0;
        img {
          border: ${(props) => (props.color === "" ? `4px solid #FFFFFF` : `4px solid ${props.color}`)};
          max-width: 175px;
          height: 175px;
          border-radius: 100%;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 125px;
            height: 125px;
          }
        }
        span {
          background: ${(props) => props.color};
          padding: 2px 12px;
          border-radius: 15px;
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translate(-50%, 0);
          font-size: 18px;
          color: #ffffff;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            border-radius: 11px;
            font-size: 13px;
          }
        }
      }
      .send-btn {
        position: absolute;
        right: 0;
        top: 0px;
        z-index: 1;
      }
    }
    .middle-row {
      .total-delivered {
        font-family: "Roboto Slab";
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0px;
        margin-bottom: 16px;
        white-space: nowrap;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
        }
        .total-delivered-text {
          color: #424B50;
        }
        .total-delivered-numericals {
          color: #1EC252;
        }
      }
      .loader {
        svg {
          max-width: 100%;
        }
      }
      .comapny-row {
        .company-logo {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 28px;
            height: 28px;
            border-radius: 6px;
          }
          img {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 28px;
              height: 28px;
              border-radius: 6px;
            }
          }
        }
        .company-details {
          margin-bottom: 25px;
          padding: 0 12px;
          min-height: 20px;
          p{
            width: 235px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 180px;
            }
          }
          .name {
            font-family: "Roboto", sans-serif;
            font-weight: 500;
            color: #424b50;
            font-size: 18px;
            line-height: 24px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 13px;
              line-height: 16px;
            }
          }
          .designation {
            font-size: 14px;
            color: #27ce0a;
            font-weight: 500;
            font-family: "Roboto", sans-serif;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 10px;
              line-height: 17px;
            }
          }
          .custom-select.open .custom-options {
            width: 270px;
            right: 0px;
            left: auto;
            margin-top: 10px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              top: 30px;
            }
          }
          .campaigns-list{
            width: 160px;
            position: absolute;
            right: 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 130px;
            }
          }
        }
        .company-action {
          margin-top: 7px;
          ul {
            margin: 0;
            padding: 0;
            list-style-type: none;
            display: block;
            li {
              margin: 0 5px;
              padding: 0 5px;
              cursor: pointer;
              list-style-type: none;
              text-align: center;
              display: inline;
              float: left;
              img {
                max-width: 16px;
                margin: 0 auto;
                display: block;
              }
              span {
                color: #a0a0a0;
                font-size: 14px;
                font-family: "Roboto", sans-serif;
                font-weight: 500;
              }
            }
          }
        }
        .edit-btn-col {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding-bottom: 7px;
        }
      }
      .instasite {
        button {
          width: 100%;
          -ms-flex-pack: justify !important;
          justify-content: space-between !important;
          span.label {
            line-height: 26px;
          }
        }
      }
      .tabs-wrapper {
        justify-content: space-between;
        align-items: center;
        margin-left: -5px;
        ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
          display: flex;
          li {
            margin: 5px 5px;
            .wrapper {
              padding: 7px 12px;
            }
          }
        }
      }
      .tabs-content-wrapper {
        background-color: #f9f8f6;
        margin: -45px -25px;
        padding: 15px 40px 45px 40px;
        box-sizing: content-box;
        max-width: calc(100% - 35px);
        min-height: calc(100vh - 630px);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: -45px -23px;
          padding: 15px 20px 45px 20px;
          max-width: 100%;
          min-height: calc(100vh - 480px);
        }
      }
      .engagement {
        border-radius: 12px;
        background-color: #1971eb;
        color: #ffffff;
        font-size: 16px;
        font-family: "robotomedium";
        font-weight: 500;
        padding: 0px 10px;
        display: inline;
        float: right;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
          padding: 0px 8px 2px 6px;
          border-radius: 9px;
        }
      }
      .edit-wrapper {
        display: flex;
        margin-top: 50px;
        margin-bottom: 48px;
        position: relative;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 20px;
          margin-bottom: 30px;
        }
        .new-campaign {
          color: #424b50;
          font-size: 40px;
          line-height: 46px;
          margin-bottom: 0px;
          display: inline-block;
          font-family: "Roboto Slab", serif;
          width: 100%;
          float: left;
          /* display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis; */
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 28px;
            line-height: 34px;
          }
          div.ant-typography,
          .ant-typography p {
            margin: 0;
          }
        }
        .edit-icon {
          margin-left: 5px;
          cursor: pointer;
          position: absolute;
          right: 0;
          bottom: 5px;
        }
        .name {
          width: 100%;
          input {
            width: 100%;
          }
          .tooltip {
            position: relative;
            display: inline-block;
            opacity: 1;
            z-index: 0;
            .tooltiptext {
              color: #ffffff;
              font-size: 11px;
              letter-spacing: 0.02px;
              line-height: 15px;
              text-align: center;
              background-color: #263153;
              visibility: hidden;
              border-radius: 4px;
              padding: 5px 0;
              position: absolute;
              z-index: 1;
              bottom: 125%;
              left: 50%;
              transform: translateX(-50%);
              opacity: 0;
              transition: opacity 0.3s;
              padding: 5px 10px;
              &:after {
                content: "";
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: #263153 transparent transparent transparent;
              }
            }
            &:hover .tooltiptext {
              visibility: visible;
              opacity: 1;
            }
          }
        }
        .editable {
          position: absolute;
          top: 15px;
          left: 0;
          width: 100%;
          display: none;
          label {
            display: none;
          }
          input {
            padding-right: 70px;
          }
          .save {
            position: absolute;
            top: 9px;
            right: 10px;
            height: 100%;
            cursor: pointer;
            img {
              vertical-align: middle;
              max-width: 20px;
            }
          }
          .cancel {
            position: absolute;
            top: 9px;
            right: 40px;
            height: 100%;
            cursor: pointer;
            img {
              vertical-align: middle;
              max-width: 20px;
            }
          }
        }
        &.editable-active {
          .new-campaign {
            opacity: 0;
          }
          .editable {
            display: block;
          }
        }
      }
    }
  }
`;
